import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../client'
import { BASE_URL } from './shared'

export interface StartDateAvailability {
  minimumStartDate: string
  unavailableStartDate: string | null
  availableStartDates?: StartDateOption[]
}

export interface StartDateOption {
  date: string
  label: string
  scheduleLabel: string
}

export function useStartDateAvailability(enabled: boolean, sponsorCompanyId?: string | null) {
  return useQuery({
    queryKey: ['enrollment', 'start-date-availability', sponsorCompanyId],
    queryFn: async () => {
      const response = await apiClient.get<StartDateAvailability>(
        `${BASE_URL}/catalog/start-date-availability`,
        { params: { sponsorCompanyId: sponsorCompanyId || undefined } }
      )
      return response.data
    },
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always'
  })
}
